import { GmbHDetails } from "lib/models/client/GmbHDetails";
import { getWepaBookings_getWepaBookings_bookings } from "lib/api/queries/graphql/getWepaBookings";
import { StorageConfigStructure } from "components/client/company/components/GetStorageConfig";
import BrokerageAccountList from "client/components/BrokerageAccountList/BrokerageAccountList";
import ConfirmAccountingYear from "client/components/ConfirmAccountingYear/ConfirmAccountingYear";
import DocumentSection from "client/components/DocumentSection/DocumentSection";
import React from "react";
import { useHistory } from "react-router-dom";

interface WepaGeneralDataProps {
  gmbh: GmbHDetails;
  bookings: getWepaBookings_getWepaBookings_bookings[];
  onConfirmBooking: (bookingId: number) => void;
  wepaStructure: StorageConfigStructure[];
}

export const WepaGeneralData = ({
  gmbh,
  bookings,
  onConfirmBooking,
  wepaStructure
}: WepaGeneralDataProps) => {
  const history = useHistory();
  const handleEditBrokerageAccount = (id: string) => {
    history.push(`/client/entities/${gmbh.id}/securities-booking/edit/${id}`);
  };

  const handleAddBrokerageAccount = () => {
    history.push(`/client/entities/${gmbh.id}/securities-booking/new`);
  };

  return (
    <div data-testid="wepa-service-general-data">
      <BrokerageAccountList
        list={gmbh.brokerageAccounts ?? []}
        onEdit={handleEditBrokerageAccount}
        onAdd={handleAddBrokerageAccount}
      />
      <ConfirmAccountingYear
        companyId={gmbh.id}
        bookings={bookings}
        onConfirmBooking={onConfirmBooking}
      />
      {gmbh.hasWepaStorage && (
        <>
          <DocumentSection
            testid="wepa"
            storageConfig={wepaStructure}
            gmbh={gmbh}
            nodeList={gmbh.wepaNodeList}
          />
        </>
      )}
    </div>
  );
};
